import React, { FC } from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
import { fadeInAndUp } from '../../../../../constants/keyframes/movement';

const StyledWrapper = styled.div`
	animation: ${fadeInAndUp} 400ms ease;
`;

const PlaceHolderLoader: FC = () => {
	return (
		<StyledWrapper>
			<ContentLoader height={247}>
				<rect x="0" y="17" rx="4" ry="4" width="200" height="13" />
				<rect x="0" y="40" rx="3" ry="3" width="350" height="40" />
				<rect x="0" y="90" rx="4" ry="4" width="150" height="10" />
				<rect x="0" y="110" rx="4" ry="4" width="400" height="2" />

				<rect x="0" y="137" rx="4" ry="4" width="200" height="13" />
				<rect x="0" y="160" rx="3" ry="3" width="350" height="40" />
				<rect x="0" y="210" rx="4" ry="4" width="150" height="10" />
				<rect x="0" y="230" rx="4" ry="4" width="400" height="2" />
			</ContentLoader>
		</StyledWrapper>
	);
};

export default PlaceHolderLoader;
